import React from 'react';
import DeviationDropZonePopup from '../DeviationDropZonePopup';
import OriginalsDeliveryDropZonePopup from '../OriginalsDeliveryDropZonePopup';

interface Props {
  tierId?: number;
  originalsDeviationId?: number;
  originalsResponseId?: number;
  isPageLoadModal?: boolean;
  onDeviationCreated: (deviationId: number) => void;
  requestClose: () => void;
}

const DeviationDropZoneWrapper: React.FC<Props> = ({
  originalsDeviationId,
  originalsResponseId,
  ...props
}) => {
  const isOriginalsDelivery = originalsDeviationId && originalsResponseId;
  if (isOriginalsDelivery) {
    const uploadParams = {
      originalsDeviationId,
      originalsResponseId,
    };
    return (
      <OriginalsDeliveryDropZonePopup uploadParams={uploadParams} {...props} />
    );
  }

  return <DeviationDropZonePopup {...props} />;
};

export default DeviationDropZoneWrapper;
